import { Box, Collapse, IconButton, Typography } from '@material-ui/core'
import { useEffect } from 'react'
import Alert from '@mui/material/Alert'
import { Close } from '@material-ui/icons'

export const AlertMessage = ({
  isError,
  message,
  open,
  setOpen,
  errors = [],
  setMessage,
}) => {
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setMessage('')
        setOpen(false)
      }, 3000)
    }
  }, [open])

  const getMessageError = (error) => {
    const typesDocs = ['Image', 'ImageFireForget', 'Devis', 'Facture']
    const types = [
      'TextArea',
      'Text',
      'Number',
      'Boolean',
      'PrestaReference',
      'UserReference',
      'UrgenceSelect',
      'ThemeType',
      'CoproprietairesReferenceFilteredCopro',
      'Grade',
      'ContractReferenceFilteredCopro',
      'Type',
      'time_type',
    ]
    if (types.includes(error.type)) {
      return `Le champ ${error.label} est obligatoire`
    } else if (typesDocs.includes(error.type)) {
      return `Vous devez uploader au moins un document pour ${error.label}`
    } else {
      return `Le champ ${error.label} est obligatoire`
    }
  }

  return (
    <>
      <Box sx={{ width: '100%', marginTop: 16 }}>
        <Collapse in={open}>
          <Alert
            severity={isError ? 'error' : 'success'}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false)
                }}
              >
                <Close fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            <Typography
              sx={{ fontSize: { xs: '16px' }, lineHeight: { xs: '1.5' } }}
            >
              {message}
            </Typography>
            <Typography
              sx={{ fontSize: { xs: '16px' }, lineHeight: { xs: '1.5' } }}
            >
              <ul>
                {errors.map((error) => {
                  return <li>{getMessageError(error)}</li>
                })}
              </ul>
            </Typography>
          </Alert>
        </Collapse>
      </Box>
    </>
  )
}
export default AlertMessage
